var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.226 347.625L220.928 340.397C220.928 340.397 219.01 336.415 212.078 336.562C205.588 331.99 194.379 321.223 194.379 321.223L188.774 306.03C188.774 306.03 193.347 304.703 194.379 301.016C195.411 297.328 194.084 292.756 193.641 292.314C193.199 291.871 188.627 293.051 187.299 294.969C185.972 296.887 183.907 304.261 180.809 301.754C177.712 299.246 181.252 296.444 181.252 296.444C181.252 296.444 184.349 292.61 184.202 290.544C184.055 288.479 180.073 282.285 179.63 282.137C179.187 281.99 178.303 290.25 177.122 291.135C175.942 292.021 174.32 295.707 171.96 293.642C169.6 291.577 173.14 288.479 173.14 288.479C173.14 288.479 179.777 284.94 173.287 273.287C171.369 278.302 167.683 281.547 167.683 281.547C167.683 281.547 165.912 284.645 164.29 281.989C162.668 279.334 166.208 276.827 166.208 276.827C166.208 276.827 171.96 273.434 172.108 268.419C172.255 263.405 165.176 257.652 165.176 257.652C165.176 257.652 164.734 266.945 162.521 268.125C160.308 269.304 159.424 271.222 156.916 269.157C154.409 267.092 158.834 262.52 158.834 262.52C158.834 262.52 166.504 254.85 166.061 250.425C165.619 246 165.176 245.263 165.176 245.263C165.176 245.263 159.424 248.803 158.687 250.572C157.949 252.343 155.589 258.685 152.639 256.767C150.574 254.408 154.409 249.835 154.409 249.835C154.409 249.835 157.212 246.738 157.064 245.41C156.917 244.082 154.705 240.1 150.427 236.265C149.837 235.085 149.542 230.365 149.542 230.365C149.542 230.365 146.297 234.2 146.445 236.265C146.592 238.33 146.15 242.46 146.592 247.032C147.035 251.605 143.052 245.557 143.052 245.557L143.79 230.808C143.79 230.808 138.185 224.022 131.401 221.516C133.908 225.203 133.76 228.743 133.76 228.743C133.76 228.743 130.958 234.79 130.958 236.413C130.958 238.035 134.203 245.115 140.25 249.835C131.105 239.953 119.749 243.197 116.356 241.28C117.979 243.197 122.846 250.425 122.257 252.342C121.667 254.26 130.959 258.242 130.959 258.242L140.841 258.39C140.841 258.39 145.708 261.781 146.15 263.994C146.593 266.207 139.071 259.864 136.121 260.012C133.171 260.159 125.354 258.98 125.354 258.98C125.354 258.98 130.074 263.404 130.221 265.322C130.368 267.24 132.433 271.664 135.236 272.845C138.038 274.024 145.56 274.468 145.56 274.468C145.56 274.468 148.804 272.549 149.395 274.614C149.985 276.679 145.118 278.302 145.118 278.302C145.118 278.302 140.104 278.302 138.481 276.974C136.858 275.647 136.563 273.434 129.336 272.549C128.599 278.597 133.318 284.791 133.318 284.791C133.318 284.791 153.23 283.169 153.082 287.447C152.934 291.724 136.563 287.889 135.973 286.561C135.383 285.234 136.711 294.968 140.545 297.033C144.38 299.098 152.935 298.066 153.967 297.624C155 297.181 158.834 296.738 158.834 298.951C158.834 301.164 139.366 302.934 139.071 302.344C138.776 301.753 142.021 309.866 149.838 309.424C157.655 308.981 161.047 306.621 161.047 306.621C161.047 306.621 165.767 305.735 166.209 307.653C166.652 309.571 161.489 310.456 161.489 310.456C161.489 310.456 149.1 310.751 148.658 310.16C148.215 309.57 151.461 317.978 160.162 317.831C166.652 317.24 167.094 314.437 168.422 313.995C170.339 313.554 174.469 313.554 175.059 313.701C175.649 313.848 185.974 321.075 185.974 321.075L212.226 347.625L212.226 347.625Z",
    fill: "#479951",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.121 231.102C136.121 231.102 135.826 245.261 142.906 249.539Z",
    fill: "#188400"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.121 231.102C136.121 231.102 135.826 245.261 142.906 249.539",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.018 242.312C151.018 242.312 155.737 249.54 147.773 252.194Z",
    fill: "#188400"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.018 242.312C151.018 242.312 155.737 249.54 147.773 252.194",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.534 247.18C126.534 247.18 125.944 255.291 140.251 254.702Z",
    fill: "#188400"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.534 247.18C126.534 247.18 125.944 255.291 140.251 254.702",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M161.932 254.26C161.932 254.26 159.572 260.012 153.82 259.717Z",
    fill: "#188400"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M161.932 254.26C161.932 254.26 159.572 260.012 153.82 259.717",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M167.242 267.238C167.242 267.975 168.274 275.793 160.752 275.645Z",
    fill: "#188400"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M167.242 267.238C167.242 267.975 168.274 275.793 160.752 275.645",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.254 263.994C131.254 263.994 140.693 269.895 144.97 269.452Z",
    fill: "#188400"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M131.254 263.994C131.254 263.994 140.693 269.895 144.97 269.452",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.318 278.301C133.318 278.301 137.743 283.021 145.855 281.84Z",
    fill: "#188400"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.318 278.301C133.318 278.301 137.743 283.021 145.855 281.84",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M172.256 281.547C172.256 282.137 170.782 286.71 167.536 287.3Z",
    fill: "#188400"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M172.256 281.547C172.256 282.137 170.782 286.71 167.536 287.3",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M140.693 292.02C140.693 292.02 144.233 296.591 153.525 294.084Z",
    fill: "#188400"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M140.693 292.02C140.693 292.02 144.233 296.591 153.525 294.084",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M181.105 290.102C181.105 290.102 179.63 297.329 175.796 297.476Z",
    fill: "#188400"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M181.105 290.102C181.105 290.102 179.63 297.329 175.796 297.476",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M190.102 297.918C190.102 297.918 187.152 306.62 179.63 305.293Z",
    fill: "#188400"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M190.102 297.918C190.102 297.918 187.152 306.62 179.63 305.293",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M155.442 313.405C155.442 313.405 158.392 316.06 165.618 312.814Z",
    fill: "#188400"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M155.442 313.405C155.442 313.405 158.392 316.06 165.618 312.814",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M147.33 304.556C147.92 304.556 151.607 307.653 160.457 302.934Z",
    fill: "#188400"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M147.33 304.556C147.92 304.556 151.607 307.653 160.457 302.934",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M212.212 336.785C212.212 336.785 206.701 339.253 212.047 347.56Z",
    fill: "#188400"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M212.212 336.785C212.212 336.785 206.701 339.253 212.047 347.56",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M383.233 233.395C383.233 233.395 380.421 273.585 380.284 273.494C380.148 273.402 374.419 266.473 374.419 266.473L356.737 321.908L360.87 334L350.575 367.757L342.085 356.987L328.369 362.502L339.379 326.949L349.551 319.641L367.866 265.029L357.701 266.302L383.233 233.395L383.233 233.395Z",
    fill: "#4BB7C0",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M422.309 249.973C422.309 249.973 400.923 284.117 400.846 283.972C400.768 283.827 398.972 275.016 398.972 275.016L363.83 307.616L326.304 343.825L326.201 336.367L313.361 334.781L330.344 321.787L339.041 320.354L393.867 270.659L384.299 267.001L422.309 249.973H422.309Z",
    fill: "#4BB7C0",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M326.33 336.308C326.562 335.823 345.842 319.35 345.842 319.35Z",
    fill: "#00CEDE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M326.33 336.308C326.562 335.823 345.842 319.35 345.842 319.35",
    stroke: "black",
    strokeWidth: 0.961964
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M410.883 221.088C410.883 221.088 400.43 259.997 400.314 259.881C400.198 259.766 395.901 251.867 395.901 251.867L353.508 324.692L355.25 337.352L340.035 365.228L333.763 353.032L319.246 355.82L335.505 326.319L346.888 321.092L389.744 249.195L379.524 248.499L410.883 221.088L410.883 221.088Z",
    fill: "#4BB7C0",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M333.996 352.568C333.996 352.336 348.63 326.783 348.63 326.783Z",
    fill: "#00CEDE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M333.996 352.568C333.996 352.336 348.63 326.783 348.63 326.783",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M213.465 215.634C213.465 215.634 203.973 225.847 199.226 218.224C194.48 210.601 205.842 208.443 205.986 208.298C206.13 208.155 212.603 206.141 213.177 194.203C213.753 182.264 198.938 174.497 194.767 173.49C190.596 172.483 178.371 172.483 178.371 172.483C178.371 172.483 133.641 161.696 129.038 158.388C124.435 155.079 82.1496 147.312 82.1496 147.312C82.1496 147.312 75.3899 146.449 75.9654 152.49C76.541 158.532 82.1496 159.25 82.1496 159.25C82.1496 159.25 77.4029 162.99 77.9785 166.299C78.554 169.607 82.1496 174.929 89.6289 174.066C88.7661 185.86 105.162 187.73 105.162 187.73C105.162 187.73 106.888 204.702 121.991 203.84C125.586 215.49 139.106 215.922 139.106 215.922C139.106 215.922 145.434 223.833 154.639 224.408C159.96 237.641 171.467 233.901 171.467 233.901C171.467 233.901 170.604 242.243 175.925 242.243C173.192 251.736 183.404 253.031 187.287 251.161C188.294 253.174 191.746 259.359 199.657 255.476C204.402 262.524 212.17 259.216 212.17 259.216C212.17 259.216 213.896 264.826 220.655 262.668C227.417 260.509 213.322 215.921 213.465 215.634L213.465 215.634Z",
    fill: "#F1C40F",
    stroke: "black",
    strokeWidth: 0.942312,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M184.125 180.826C184.125 180.826 194.624 181.977 193.33 198.23Z",
    fill: "#F1C40F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M184.125 180.826C184.125 180.826 194.624 181.977 193.33 198.23",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M144.141 163.998C144.141 163.998 124.005 177.806 161.689 182.121Z",
    fill: "#F1C40F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M144.141 163.998C144.141 163.998 124.005 177.806 161.689 182.121",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M149.894 180.25C149.751 180.537 140.401 191.613 157.661 194.921C149.462 202.688 164.852 205.277 164.852 205.277C164.852 205.277 161.688 213.475 170.893 215.633C167.873 224.119 177.796 223.688 177.796 223.688C177.796 223.688 178.084 234.044 189.878 233.901C189.734 240.949 197.932 241.38 197.932 241.38C197.932 241.38 200.378 249.003 208.288 246.702C209.151 252.023 214.616 250.873 214.616 250.873",
    fill: "#F1C40F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M149.894 180.25C149.751 180.537 140.401 191.613 157.661 194.921C149.462 202.688 164.852 205.277 164.852 205.277C164.852 205.277 161.688 213.475 170.893 215.633C167.873 224.119 177.796 223.688 177.796 223.688C177.796 223.688 178.084 234.044 189.878 233.901C189.734 240.949 197.932 241.38 197.932 241.38C197.932 241.38 200.378 249.003 208.288 246.702C209.151 252.023 214.616 250.873 214.616 250.873",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M212.315 259.36C212.315 259.36 212.747 252.024 211.021 250.586Z",
    fill: "#FFD600"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M212.315 259.36C212.315 259.36 212.747 252.024 211.021 250.586",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M199.227 255.331C199.371 255.187 202.679 248.571 201.528 247.42Z",
    fill: "#FFD600"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M199.227 255.331C199.371 255.187 202.679 248.571 201.528 247.42",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M187.146 251.161L196.063 242.387Z",
    fill: "#FFD600"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M187.146 251.161L196.063 242.387",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M175.927 242.531C176.071 242.387 189.446 234.045 189.446 234.045Z",
    fill: "#FFD600"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M175.927 242.531C176.071 242.387 189.446 234.045 189.446 234.045",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M171.181 234.045C171.325 233.901 178.803 230.737 179.092 228.004Z",
    fill: "#FFD600"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M171.181 234.045C171.325 233.901 178.803 230.737 179.092 228.004",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M154.64 224.406C154.64 224.406 172.762 228.29 175.927 224.119Z",
    fill: "#E5B731"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M154.64 224.406C154.64 224.406 172.762 228.29 175.927 224.119",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M139.539 215.777C140.257 215.777 166.722 218.654 169.167 215.346Z",
    fill: "#E5B731"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M139.539 215.777C140.257 215.777 166.722 218.654 169.167 215.346",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M121.991 203.839C122.423 203.694 153.345 209.592 162.119 205.133Z",
    fill: "#E5B731"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M121.991 203.839C122.423 203.694 153.345 209.592 162.119 205.133",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M107.177 187.873C107.897 187.873 148.312 197.654 154.353 194.633Z",
    fill: "#E5B731"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M107.177 187.873C107.897 187.873 148.312 197.654 154.353 194.633",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7874 173.777C92.0747 173.777 139.97 184.997 146.01 180.393Z",
    fill: "#E5B731"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7874 173.777C92.0747 173.777 139.97 184.997 146.01 180.393",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6033 160.113C85.7465 160.113 131.485 175.072 135.367 171.332Z",
    fill: "#E5B731"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6033 160.113C85.7465 160.113 131.485 175.072 135.367 171.332",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M300.388 208.602C300.388 206.43 299.683 202.213 297.388 200.754C294.44 199.221 294.44 198.278 294.205 196.274C293.969 194.27 299.155 190.498 299.155 190.498C299.155 190.498 294.44 188.376 292.672 188.612C290.905 188.848 287.486 189.201 287.015 189.673C286.543 190.145 283.95 181.186 285.6 179.771C287.25 178.356 290.668 183.072 290.668 183.072C290.668 183.072 292.907 177.885 285.01 167.984C287.722 148.652 269.687 144.172 265.561 144.29C262.143 143.819 253.303 147.002 251.888 151.245C247.409 152.777 247.173 156.668 247.173 156.668C247.173 156.668 237.98 158.318 236.8 166.334C242.222 161.855 245.759 166.806 245.759 166.806C245.759 166.806 250.474 170.106 252.949 170.224C255.423 170.343 250.591 178.476 249.177 179.891C247.763 181.305 241.869 186.728 242.104 187.081C242.34 187.434 246.701 188.731 246.466 190.735C246.23 192.739 233.028 198.869 233.735 200.401C237.154 199.34 239.819 200.157 239.819 200.157C240.295 203.504 238.962 207.358 236.687 208.606L300.389 208.602L300.388 208.602Z",
    fill: "#F1C40F",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M246.813 157.199L251.084 161.471C252.242 161.833 258.758 165.018 258.396 167.19",
    fill: "#FFD600"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M246.813 157.199L251.084 161.471C252.242 161.833 258.758 165.018 258.396 167.19",
    stroke: "black",
    strokeWidth: 0.941682
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M258.396 167.189C258.034 169.361 253.763 170.447 253.763 170.447Z",
    fill: "#FFD600"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M258.396 167.189C258.034 169.361 253.763 170.447 253.763 170.447",
    stroke: "black",
    strokeWidth: 0.941682,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M251.953 151.408L258.468 157.634C258.468 157.634 259.626 162.991 264.26 162.557C268.893 162.123 268.241 160.168 268.241 160.168C268.241 160.168 262.668 156.258 258.252 157.199",
    fill: "#E5B731"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M251.953 151.408L258.468 157.634C258.468 157.634 259.626 162.991 264.26 162.557C268.893 162.123 268.241 160.168 268.241 160.168C268.241 160.168 262.668 156.258 258.252 157.199",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M320.473 264.309C320.473 264.309 326.265 269.869 326.381 271.028C326.497 272.186 327.887 277.63 329.393 278.442C330.898 279.253 336.807 284.002 337.617 285.856C338.428 287.71 343.641 295.586 343.641 295.586C343.641 295.586 348.506 305.548 351.749 306.36C354.993 307.17 364.144 305.781 365.997 310.183C367.85 314.585 367.387 320.957 367.387 320.957C367.387 320.957 365.186 322.926 364.144 321.767C363.102 320.609 361.248 327.559 358.004 325.59C353.586 316.183 342.024 317.718 342.024 317.718C342.024 317.718 344.567 313.774 334.258 310.299C318.156 313.079 313.407 296.282 313.407 296.282L304.242 288.333L320.473 264.309L320.473 264.309Z",
    fill: "#F1C40F",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M311.206 288.172L318.388 291.532L317.809 285.393",
    fill: "#E5B731"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M311.206 288.172L318.388 291.532L317.809 285.393",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M321.4 287.245L328.002 290.489L325.339 285.16",
    fill: "#E5B731"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M321.4 287.245L328.002 290.489L325.339 285.16",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M321.052 278.558L327.539 282.033L324.527 275.314",
    fill: "#E5B731"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M321.052 278.558L327.539 282.033L324.527 275.314",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M331.362 310.415C331.362 310.415 323.948 300.684 324.064 300.684C324.18 300.684 336.69 303.116 336.69 303.116L332.057 293.154L343.525 296.166",
    fill: "#E5B731"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M331.362 310.415C331.362 310.415 323.948 300.684 324.064 300.684C324.18 300.684 336.69 303.116 336.69 303.116L332.057 293.154L343.525 296.166",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M352.676 311.92C352.676 311.92 359.974 313.542 359.742 325.706Z",
    fill: "#E5B731"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M352.676 311.92C352.676 311.92 359.974 313.542 359.742 325.706",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M356.499 310.067C356.499 310.067 364.376 309.604 363.912 321.882Z",
    fill: "#E5B731"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M356.499 310.067C356.499 310.067 364.376 309.604 363.912 321.882",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M220.648 265.815C220.648 265.815 214.856 271.375 214.74 272.533C214.624 273.691 212.273 278.415 210.768 279.226C209.262 280.037 204.075 285.267 203.264 287.122C202.453 288.975 197.481 297.092 197.481 297.092C197.481 297.092 191.775 305.373 188.531 306.184C184.567 306.515 176.977 307.286 175.124 311.688C173.271 316.091 176.136 322.822 178.298 322.822C181.541 324.263 183.021 325.752 184.064 324.593C185.826 325.116 184.818 326.625 188.062 324.656C185.597 321.497 185.86 318.444 188.331 317.643C190.796 316.8 194.811 320.551 194.811 320.551C194.811 320.551 196.273 313.73 206.583 310.254C222.684 313.034 227.011 300.041 228.138 296.942C230.677 293.486 234.625 292.566 237.868 290.379L220.648 265.814L220.648 265.815Z",
    fill: "#F1C40F",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M230.196 288.27L222.732 292.193L223.312 286.898",
    fill: "#F1C40F"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M230.196 288.27L222.732 292.193L223.312 286.898",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M220.285 287.203C220.285 287.203 214.99 292.359 213.26 290.446C211.84 288.875 216.487 284.977 216.487 284.977",
    fill: "#F1C40F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M220.285 287.203C220.285 287.203 214.99 292.359 213.26 290.446C211.84 288.875 216.487 284.977 216.487 284.977",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M220.491 278.655L214.427 281.285L216.594 276.82",
    fill: "#F1C40F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M220.491 278.655L214.427 281.285L216.594 276.82",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M210.041 310.371C211.168 308.117 216.891 301.063 216.775 301.063C216.659 301.063 204.993 303.496 204.993 303.496L208.782 293.674L198.582 295.699",
    fill: "#F1C40F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M210.041 310.371C211.168 308.117 216.891 301.063 216.775 301.063C216.659 301.063 204.993 303.496 204.993 303.496L208.782 293.674L198.582 295.699",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M188.925 311.865C188.925 311.865 180.066 313.487 183.54 324.449Z",
    fill: "#FFD600"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M188.925 311.865C188.925 311.865 180.066 313.487 183.54 324.449",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M185.103 310.371C185.103 310.371 175.425 310.628 178.77 322.667Z",
    fill: "#F1C40F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M185.103 310.371C185.103 310.371 175.425 310.628 178.77 322.667",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M296.894 296.934C296.894 296.934 297.495 304.02 294.492 307.023C307.824 307.863 315.03 321.436 315.15 324.679C315.269 327.921 311.066 330.443 311.066 330.443C311.066 330.443 312.508 336.209 306.982 337.17C307.102 342.694 303.259 342.694 303.259 342.694C303.259 342.694 301.818 347.259 297.375 347.019C296.053 353.624 289.208 353.504 289.208 353.504C289.208 353.504 285.244 363.113 279.359 359.39C275.636 367.557 265.788 367.197 262.065 359.39C260.023 359.27 255.46 362.032 252.697 353.865C246.572 354.946 244.17 347.139 244.17 347.139C244.17 347.139 240.086 346.779 238.525 342.695C233.721 341.734 234.562 336.93 234.562 336.93C234.562 336.93 229.758 335.609 229.878 330.325C226.034 328.042 226.395 323.959 226.395 323.959C226.395 323.959 229.398 309.787 246.812 306.784C244.049 302.821 244.41 297.056 244.41 297.056L296.895 296.934L296.894 296.934Z",
    fill: "#F1C40F",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M283.683 307.264C283.683 307.504 285.485 315.071 279.599 316.272C291.25 313.149 303.379 342.695 303.379 342.695",
    fill: "#FFD600"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M283.683 307.264C283.683 307.504 285.485 315.071 279.599 316.272C291.25 313.149 303.379 342.695 303.379 342.695",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M287.647 304.5C287.647 304.5 289.208 310.506 284.044 313.508C302.779 317.592 307.103 337.049 307.103 337.049",
    fill: "#FFD600"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M287.647 304.5C287.647 304.5 289.208 310.506 284.044 313.508C302.779 317.592 307.103 337.049 307.103 337.049",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M291.729 301.497C291.729 301.377 294.972 309.664 288.007 311.106C305.902 309.785 310.946 330.202 310.946 330.202",
    stroke: "black",
    strokeWidth: 1.17751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M278.038 310.627C278.038 310.627 281.041 316.391 275.516 318.193C285.965 319.274 289.328 353.624 289.328 353.624",
    fill: "#FFD600"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M278.038 310.627C278.038 310.627 281.041 316.391 275.516 318.193C285.965 319.274 289.328 353.624 289.328 353.624",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M274.435 312.668C274.435 312.668 276.116 319.033 270.712 320.955C281.641 315.191 279.599 359.629 279.599 359.629",
    fill: "#E5B731"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M274.435 312.668C274.435 312.668 276.116 319.033 270.712 320.955C281.641 315.191 279.599 359.629 279.599 359.629",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M267.229 313.029C267.229 313.029 264.947 319.755 269.992 321.076C260.024 318.314 261.945 359.631 261.945 359.631",
    fill: "#F1C40F"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M267.229 313.029C267.229 313.029 264.947 319.755 269.992 321.076C260.024 318.314 261.945 359.631 261.945 359.631",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M262.545 310.387C262.545 310.387 260.984 316.512 267.109 319.634C256.901 313.149 252.697 354.105 252.697 354.105",
    fill: "#FFD600"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M262.545 310.387C262.545 310.387 260.984 316.512 267.109 319.634C256.901 313.149 252.697 354.105 252.697 354.105",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M278.759 316.031C278.759 316.031 297.373 333.927 297.254 347.138Z",
    fill: "#FFD600"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M278.759 316.031C278.759 316.031 297.373 333.927 297.254 347.138",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M249.335 301.617C249.335 301.737 247.053 311.226 253.659 311.466Z",
    fill: "#FFD600"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M249.335 301.617C249.335 301.737 247.053 311.226 253.659 311.466",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M254.019 305.102C254.019 305.342 252.217 313.148 257.501 313.509Z",
    fill: "#FFD600"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M254.019 305.102C254.019 305.342 252.217 313.148 257.501 313.509",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M258.222 307.383C258.222 307.383 254.979 315.19 262.905 316.27Z",
    fill: "#FFD600"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M258.222 307.383C258.222 307.383 254.979 315.19 262.905 316.27",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M262.305 316.391C262.185 316.391 246.812 330.684 244.41 347.258Z",
    fill: "#FFD600"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M262.305 316.391C262.185 316.391 246.812 330.684 244.41 347.258",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M259.423 314.949C259.303 314.949 239.847 327.08 238.525 342.573Z",
    fill: "#FFD600"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M259.423 314.949C259.303 314.949 239.847 327.08 238.525 342.573",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M255.1 312.908C255.1 312.908 233.482 325.519 234.442 336.929Z",
    fill: "#F1C40F"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M255.1 312.908C255.1 312.908 233.482 325.519 234.442 336.929",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M249.934 310.145C249.934 310.145 233.841 313.147 229.878 330.443Z",
    fill: "#FFD600"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M249.934 310.145C249.934 310.145 233.841 313.147 229.878 330.443",
    stroke: "black",
    strokeWidth: 0.941997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M215.994 199.484C215.994 199.484 231.557 208.079 242.707 207.615C253.857 207.151 270.581 199.949 270.581 199.949C270.581 199.949 285.448 208.311 297.527 207.151C309.606 205.989 326.33 199.484 326.33 199.484C336.318 249.351 313.554 294.107 270.581 314.24C224.976 293.41 202.832 243.311 215.994 199.484Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M221.729 235.723V266.901L230.572 281.811V235.723H221.729Z",
    fill: "#E32D3C"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M239.414 235.723V292.176L248.257 300.406V235.723H239.414V235.723Z",
    fill: "#E32D3C"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M257.099 235.723V307.088L265.941 311.998V235.723H257.099V235.723Z",
    fill: "#E32D3C"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M318.997 235.723V266.91L310.154 281.948V235.723H318.997H318.997Z",
    fill: "#E32D3C"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M301.312 235.723V292.454L292.469 300.518V235.723H301.312V235.723Z",
    fill: "#E32D3C"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M283.627 235.723V306.953L274.785 312.221V235.723H283.627L283.627 235.723Z",
    fill: "#E32D3C"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M215.994 199.485C215.994 199.485 219.885 201.634 225.169 203.724C230.453 205.816 237.131 207.848 242.706 207.615C253.856 207.151 270.58 199.949 270.58 199.949C270.58 199.949 285.446 208.311 297.526 207.151C309.605 205.989 326.329 199.484 326.329 199.484C328.768 213.964 329.987 221.359 327.839 235.723H212.888C211.426 221.389 211.504 214.894 215.995 199.485L215.994 199.485Z",
    fill: "#2980B9"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M327.839 235.723H212.887H327.839ZM215.994 199.485C215.994 199.485 231.557 208.08 242.707 207.615C253.857 207.15 270.582 199.949 270.582 199.949C270.582 199.949 285.448 208.312 297.527 207.15C309.605 205.989 326.331 199.485 326.331 199.485C336.319 249.352 313.555 294.108 270.582 314.24C224.976 293.41 202.832 243.311 215.994 199.484L215.994 199.485Z",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M46.192 213.771L71.7438 213.888L69.1886 220.044L80.3387 264.18L93.8114 220.16L89.0491 213.772H115.646L109.955 219.928L88.004 282.996L93.6946 291.243H68.1427L73.8339 282.996L52.3473 220.16L46.1919 213.772L46.192 213.771Z",
    fill: "#4BB7C0",
    stroke: "black",
    strokeWidth: 0.941997
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M438.177 215.281H462.451L458.503 220.74L458.386 284.97L463.845 291.01H438.177L443.287 284.506L443.171 220.857L438.177 215.282V215.281Z",
    fill: "#4BB7C0",
    stroke: "black",
    strokeWidth: 0.941997
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVi);
export default __webpack_public_path__ + "static/media/VI.f986bfd96ad529edf758288623f70472.svg";
export { ForwardRef as ReactComponent };